import * as React from "react";
import type { SVGProps } from "react";
const SvgShare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24" {...props}
  >
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M8.553 10.114a2.667 2.667 0 1 1-3.772 3.772 2.667 2.667 0 0 1 3.772-3.772M19.219 4.781a2.667 2.667 0 1 1-3.772 3.772 2.667 2.667 0 0 1 3.772-3.772M19.219 15.447a2.667 2.667 0 1 1-3.772 3.772 2.667 2.667 0 0 1 3.772-3.772M9.04 10.81l5.92-2.96M9.04 13.19l5.92 2.96"
    />
  </svg>
);
export default SvgShare;
